module.exports = __webpack_public_path__ + "static/media/8OLA17.0e8a37a2.jpg";